/**
 * ProgressBar data-hook props used for testing.
 */
export var ProgressBarDataHooks;
(function (ProgressBarDataHooks) {
    ProgressBarDataHooks["mainWrapper"] = "progressbar-main-wrapper";
    ProgressBarDataHooks["container"] = "progressbar-container";
    ProgressBarDataHooks["background"] = "progressbar-background";
    ProgressBarDataHooks["foreground"] = "progressbar-foreground";
    ProgressBarDataHooks["progressIndicator"] = "progress-indicator";
    ProgressBarDataHooks["successIcon"] = "success-icon";
    ProgressBarDataHooks["errorIcon"] = "error-icon";
    ProgressBarDataHooks["progressPercentage"] = "progress-percentages";
    ProgressBarDataHooks["prefixIndicator"] = "prefix-indicator";
    ProgressBarDataHooks["suffixIndicator"] = "suffix-indicator";
})(ProgressBarDataHooks || (ProgressBarDataHooks = {}));
/**
 * ProgressBar attribute keys used to store internal data (current value, min, max etc...)
 */
export var ProgressBarDataKeys;
(function (ProgressBarDataKeys) {
    ProgressBarDataKeys["value"] = "data-progress-value";
    ProgressBarDataKeys["min"] = "data-progress-min-value";
    ProgressBarDataKeys["max"] = "data-progress-max-value";
})(ProgressBarDataKeys || (ProgressBarDataKeys = {}));
export var ProgressBarAriaKeys;
(function (ProgressBarAriaKeys) {
    ProgressBarAriaKeys["valuenow"] = "aria-valuenow";
    ProgressBarAriaKeys["valuemax"] = "aria-valuemax";
    ProgressBarAriaKeys["valuemin"] = "aria-valuemin";
    ProgressBarAriaKeys["valuetext"] = "aria-valuetext";
})(ProgressBarAriaKeys || (ProgressBarAriaKeys = {}));
export var ProgressBarInnerAriaKeys;
(function (ProgressBarInnerAriaKeys) {
    ProgressBarInnerAriaKeys["label"] = "aria-label";
    ProgressBarInnerAriaKeys["hidden"] = "aria-hidden";
})(ProgressBarInnerAriaKeys || (ProgressBarInnerAriaKeys = {}));
//# sourceMappingURL=DataHooks.js.map